<template>
  <b-modal
    id="confirm-delete-profile-modal"
    centered
    hide-header
    modal-class="layout-modal-320"
    body-class="text-center pt-25 px-25 pb-0"
    content-class="border-radius-12 clear-border"
    footer-class="clear-border pb-35 px-25 pt-0"
  >
    <template #default>
      <p class="fs-18 f-600 cl-5e5873"
        >本当に削除しても<br />よろしいですか？</p
      >
      <div class="fs-14 cl-6e6b7b mt-25 mb-20 fs-14 f-500"
        >削除すると元の画像に戻せませんが<br />よろしいですか？</div
      >
    </template>
    <template #modal-footer="{ cancel }">
      <div class="form-button-custom w-100">
        <b-button
          class="d-flex align-items-center justify-content-center border-radius-100 py-9"
          block
          variant="danger"
          @click="$emit('ok')"
          >削除する</b-button
        >
      </div>
      <div class="form-button-custom w-100 mt-8">
        <b-button
          class="d-flex align-items-center justify-content-center border-radius-100 py-9"
          block
          @click="cancel()"
          >キャンセル</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator'

@Component
export default class UserConfirmDeleteProfileModal extends Vue {}
</script>
